export const member = {
    labels: {
    },
    modals: {
        titles: {
            member_remove: "Remove Member",
        },
        messages: {
            member_remove: "Are you sure you want to remove the member <strong>{name}</strong>?<br/>This action cannot be undone.",
        }
    },
    texts: {
    },
};
